
import { Vue, Options } from "vue-class-component";
import Alert from "@/components/alerts/Alert.vue";

@Options({
  components: {
    Alert
  }
})
export default class AlertBox extends Vue {}
